import React from 'react'
import { WrappedFieldProps } from 'redux-form'
import { IFormElementProps } from '../FormElement/FormInput'

type C = React.ComponentType<IFormElementProps>

function withRedux(Component: C) {
  return function({
                    input,
                    meta,
                    ...rest
                  }: WrappedFieldProps & IFormElementProps) {
    return (
      <Component
        name={input.name}
        value={input.value}
        onChange={input.onChange}
        onBlur={input.onBlur}
        onFocus={input.onFocus}
        errorMsg={meta.error}
        warningMsg={meta.warning}
        {...rest}
      />
    )
  }
}

export default withRedux
